import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";

export const FAQ = () => (
  <section id="faq" className="py-24 lg:py-32" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6 lg:px-12">
      <div className="text-center reveal">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">FAQ</div>
        <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
          Frequently asked <span className="text-gradient">questions</span>
        </h2>
        <p className="mt-3 text-slate-500 text-sm">Tap any question to expand — first one is open by default.</p>
      </div>

      <Accordion type="single" collapsible defaultValue="item-0" className="mt-12 space-y-3 reveal" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="bg-white border border-slate-100 rounded-2xl px-6 soft-shadow"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="text-left font-heading font-bold text-slate-900 hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed pb-5" data-testid={`faq-answer-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {/* Crawler-visible fallback so answers appear in raw HTML even before JS runs — helps AI search engines */}
      <div className="sr-only" aria-hidden="true">
        {FAQS.map((f, i) => (
          <div key={`sr-${i}`}>
            <h3>{f.q}</h3>
            <p>{f.a}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
